import { Block } from "Content/Block";
import { Card, CardContainer } from "Content/style";

export const Feedback = () => {
  return (
    <div id="feedback">
      <Block caption={"Feedback"}>
        <CardContainer>
          <Card style={{ flex: "1 0 30%" }}>
            <p>
              <i>Liebe Jenni,</i>
              <p>
                {" "}
                <i>
                  vielen Dank nochmal für Samstag, das Ergebnis ist super
                  geworden! Haare und Make up haben ohne Probleme bis in die
                  frühen Morgenstunden gehalten. 🤩
                </i>
              </p>{" "}
              Braut Sabrina
            </p>
          </Card>
          <Card>
            <p>
              <i>Liebe Jenni,</i>
              <p>
                {" "}
                <i>
                  Vielen vielen Dank nochmal für deine Arbeit. Den Hochzeits-
                  Morgen konnten wir mit deiner super entspannten Art und mit
                  richtig schönen Gesprächen starten! Und sowohl mich als auch
                  mein Trauzeugin hat deine Frisur den ganzen Tag begleitet. Das
                  Make-up hat bei mir sogar den gesamten nächsten Tag noch
                  gehalten, wie frisch geschminkt! Alle waren begeistert!
                </i>
              </p>{" "}
              Braut Bianca
            </p>
          </Card>
          <Card>
            <p>
              <i>Hey Jenni,</i>
              <p>
                {" "}
                <i>
                  wollte mich nochmal ganz herzlich bedanken. Die Frisur hat
                  super gehalten und alle haben gesagt dass ich ganz toll
                  geschminkt war. ❣️
                </i>
              </p>{" "}
              Gästestyling Jaqueline
            </p>
          </Card>
        </CardContainer>
        <CardContainer>
          <Card>
            <p>
              {" "}
              <i>
                Und es war mal wieder der absolute Hammer. Bin wirklich
                begeistert von deiner Arbeit und kann nur noch einmal Danke
                sagen 😊🥰
              </i>
            </p>{" "}
            Styling Shooting Corinna
          </Card>

          <Card>
            <p>
              {" "}
              <i>
                Danke liebe Jenni für dein tolles Styling gestern und deine
                ruhige, liebevolle Art, die mir an dem Morgen sehr gut getan hat
                😊
              </i>
            </p>{" "}
            Braut Isabel
          </Card>
          <Card>
            <p>
              {" "}
              <i>
                Hallo Jenni, ich wollte mich noch herzlich bei dir bedanken, ich
                habe mich am Samstag wirklich sehr wohl gefühlt 🥰 Vor allem das
                Make-Up war perfekt. Danke! 😊
              </i>
            </p>{" "}
            Braut Lisa
          </Card>
        </CardContainer>
      </Block>
    </div>
  );
};
